import { useEffect } from "react";
import { ensureFreshToken } from "../api/client";

const STORAGE_KEY = "last_activity";

/** Returns the stored last activity timestamp (ISO string) or null. */
export function getLastActivity() {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? new Date(raw).getTime() : null;
}

/** Update the last activity timestamp to now. */
function updateActivity() {
  localStorage.setItem(STORAGE_KEY, new Date().toISOString());
}

/**
 * Hook that tracks user activity (mouse, keyboard, touch, scroll)
 * and stores the timestamp in localStorage every few seconds.
 */
export function useActivityTracker() {
  useEffect(() => {
    let timeoutId = null;

    function onActivity() {
      // Debounce: only write to localStorage at most once per 5 seconds
      if (timeoutId) return;
      timeoutId = setTimeout(() => {
        updateActivity();
        void ensureFreshToken();
        timeoutId = null;
      }, 2000);
    }

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((ev) => window.addEventListener(ev, onActivity, { passive: true }));

    // Set initial activity
    updateActivity();

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, onActivity));
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
}
